//
// Imports
//

import * as BrowserUtilities from "@donutteam/browser-utilities";
import { initialiseForm } from "@donutteam/document-builder-components/build/client.js";

import { RequestBody, ResponseBodySchema } from "../../../../api/routes/v6/sessions/create.schemas.js";

//
// Component
//

export function initialiseCreateSessionForm(createSessionForm: HTMLFormElement)
{
	const apiUrl = BrowserUtilities.ElementClientLib.getStringDataOrThrow(createSessionForm, "apiUrl");

	const csrfTokenInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(createSessionForm, "input[name=csrfToken]");

	const loginInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(createSessionForm, "input[name=login]");

	const passwordInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(createSessionForm, "input[name=password]");

	const isAutoRenewingInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(createSessionForm, "input[name=isAutoRenewing]");

	initialiseForm(createSessionForm,
		async () =>
		{
			// Note: This input doesn't exist until the form is submitted, so we get it here instead
			const recaptchaTokenInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(createSessionForm, "input[name=recaptcha_token]");

			const requestBody: RequestBody =
			{
				csrfToken: csrfTokenInput.value,
				recaptchaToken: recaptchaTokenInput.value,

				login: loginInput.value,
				password: passwordInput.value,

				isAutoRenewing: isAutoRenewingInput.checked,
			};

			const response = await fetch(apiUrl + "/v6/sessions/create",
				{
					credentials: "include",
					method: "POST",
					headers:
					{
						"Content-Type": "application/json",
					},
					body: JSON.stringify(requestBody),
				});

			const responseBody = ResponseBodySchema.parse(await response.json());

			if (!responseBody.success)
			{
				return {
					restoreInputs: true,
					notices: responseBody.errors.map((error) => ({ type: "warning", message: error.message, dismissible: true })),
				};
			}

			const url = new URL(window.location.href);

			const next = url.searchParams.get("next");

			if (next == null)
			{
				window.location.href = "/@me";
			}
			else // if (URL.canParse(next))
			{
				try
				{
					const nextUrl = new URL(next);

					if (nextUrl.hostname === url.hostname || nextUrl.hostname.endsWith("." + url.hostname))
					{
						window.location.href = next;
					}
					else
					{
						window.location.href = "/@me";
					}
				}
				catch (error)
				{
					console.error("[CreateSessionForm] next value is not a valid URL:", next)

					window.location.href = "/@me";
				}
			}

			return {
				restoreInputs: false,
				notices: 
				[
					{
						type: "success",
						message: responseBody.accountStateChanged
							? "You have successfully logged in and your account has been reactivated. You will be redirected shortly."
							: "You have successfully logged in. You will be redirected shortly.",
						dismissible: false,
					},
				],
			};
		});

	createSessionForm.classList.add("initialised");
}

export function initialiseCreateSessionForms()
{
	const createSessionForms = document.querySelectorAll<HTMLFormElement>(".component-create-session-form:not(.initialised)");

	console.log("[CreateSessionForm] Initialising " + createSessionForms.length + " instances...");

	for (const createSessionForm of createSessionForms)
	{
		try
		{
			initialiseCreateSessionForm(createSessionForm);
		}
		catch (error)
		{
			console.error("[CreateSessionForm] Error initialising:", createSessionForm, error);
		}
	}
}